import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SourceSurveyPayload, SourceSurveyResponse } from '../models/source-survey.models';


@Injectable({ providedIn: 'root' })
export class SourceSurveyService {
private baseUrl = `${environment.apiUrl}/api/sourceUpload/source-survey`;
  constructor(private http: HttpClient) {}

  saveSurvey(payload: SourceSurveyPayload): Observable<SourceSurveyResponse> {
    return this.http.post<SourceSurveyResponse>(this.baseUrl, payload);
  }
}
